import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { first } from "rxjs/operators";
import { CameraComponent } from "src/app/annotation/camera/camera.component";
import {
  PictureData,
  PictureUploadState,
} from "src/app/annotation/canvas/canvas.component";
import { PictureInfo } from "src/app/core/survey/shared/components/photo-and-remark/photo-viewmodel";
import { FormValidationService } from "src/app/core/survey/shared/services/formValidation.service";
import { SurveyType } from "src/app/core/survey/shared/services/photo.service";
import { SavingStateService } from "src/app/core/survey/shared/services/saving-state.service";
import { SurveyPhotoTypeEnum } from "src/app/shared/Models/enums/SurveyPhotoTypeEnum";
import { PhotoIndexInfo } from "src/app/shared/Models/interfaces/PhotoIndexInfo.interface";
import { InsideSurvey } from "src/app/shared/Models/read";
import { ChangeInsideSurveyPhotoRemarksDto } from "src/app/shared/Models/write/ChangeInsideSurveyPhotoRemarksDto";
import { GeneralPhotoRemarksDto } from "src/app/shared/Models/write/generalPhotoRemarksDto";
import { LayoutDto } from "src/app/shared/Models/write/LayoutDto";
import { DataConvertingService } from "src/app/shared/services/data-converting.service";
import {
  DialogService,
  DialogType,
} from "src/app/shared/services/dialog.service";
import { InsideSurveyService } from "src/app/shared/services/inside-survey.service";
import { ToastService } from "src/app/shared/toast.service";
import {
  InsideSurveyCablingProposal,
  INSIDE_SURVEY_CABLING_PROPOSAL,
  INSIDE_SURVEY_INSIDE_TECHNICAL_INFO,
} from "../../../config/inside-survey.magic-strings";
import { InsideSurveyTab } from "../../../models/insideSurveyTab.interface";
import { InsideSurveyBuildingLayoutComponent } from "../inside-survey-building-layout-editor/inside-survey-building-layout-editor.component";
import { ValidationError } from "../../../../../../shared/Models/ValidationError";
import { DrawingLayerPhotoViewmodel } from "./photo-viewmodel";

const RESULT = "result";
@Component({
  selector: "app-inside-survey-cabling-proposal",
  templateUrl: "./inside-survey-cabling-proposal.component.html",
  styleUrls: ["./inside-survey-cabling-proposal.component.scss"],
  providers: [ToastService],
})
export class InsideSurveyCablingProposalComponent
  implements InsideSurveyTab, OnInit, AfterViewInit, OnDestroy
{
  tabId: string = INSIDE_SURVEY_CABLING_PROPOSAL;

  @Input() viewerLayer: HTMLDivElement;
  @Input() cameraLayer: HTMLDivElement;
  @Input() camera: CameraComponent;
  @ViewChild("buildingLayoutEditorLayer")
  buildingLayoutEditorLayerRef: ElementRef<HTMLDivElement>;
  buildingLayoutEditorLayer: HTMLDivElement;
  @ViewChild("buildingLayoutEditor")
  buildingLayoutEditor: InsideSurveyBuildingLayoutComponent;

  @Input() isAuthCanWrite: boolean;
  @Input() survey: InsideSurvey;

  @ViewChildren("fileInput")
  fileInputs: QueryList<ElementRef<HTMLInputElement>>;
  savedPhotoOrder: {
    generalPhotos: PhotoIndexInfo[];
  } = {
    generalPhotos: [],
  };
  unsavedPhotoOrder: {
    generalPhotos: PhotoIndexInfo[];
  } = {
    generalPhotos: [],
  };

  mainViewVisible: boolean;
  viewmodel: DrawingLayerPhotoViewmodel = {
    outsideIntroPhotos: [],
    outsideIntroComment: "",
    generalPhotos: [],
    generalComment: [],
    facadeComment: "",
    undergroundComment: "",
    facadePhotos: [],
    undergroundPhotos: [],
    floorPlanPhotos: [],
    floorPlanComment: "",
    layoutPhotoURL: "",
    layoutStatus: null,
  };

  surveyType = SurveyType;
  surveyPhotoType = SurveyPhotoTypeEnum;
  uploadStates = PictureUploadState;
  generalPhotoRemarkFieldName = "generalPhotoRemark";

  layoutHoverOverlay: boolean = false;
  insideSurveyCablingProposal = InsideSurveyCablingProposal;

  constructor(
    private insideSurveyService: InsideSurveyService,
    private toastService: ToastService,
    private dialogService: DialogService,
    private _dataConverterService: DataConvertingService,
    private _savingStateService: SavingStateService,
    private formValidationService: FormValidationService
  ) {}

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
    this.buildingLayoutEditorLayer =
      this.buildingLayoutEditorLayerRef.nativeElement;
  }

  gotPhotoCallback: (data: PictureData) => void;

  ngOnInit() {
    this.formValidationService.addFormError([INSIDE_SURVEY_CABLING_PROPOSAL], {
      [InsideSurveyCablingProposal.PHOTO_GENERAL_SUBTITLE]: {
        [InsideSurveyCablingProposal.PHOTO_GENERAL_FIELD]: false,
      },
      [InsideSurveyCablingProposal.OUTSIDE_INTRO_PHOTO_SUBTITLE]: {
        [InsideSurveyCablingProposal.OUTSIDE_INTRO_PHOTO_FIELD]: false,
      },
      [InsideSurveyCablingProposal.FACADE_PHOTO_SUBTITLE]: {
        [InsideSurveyCablingProposal.FACADE_PHOTO_FIELD]: false,
      },
      [InsideSurveyCablingProposal.UNDERGROUND_PHOTO_SUBTITLE]: {
        [InsideSurveyCablingProposal.UNDERGROUND_PHOTO_FIELD]: false,
      },
      [InsideSurveyCablingProposal.FLOOR_PLAN_PHOTO_SUBTITLE]: {
        [InsideSurveyCablingProposal.FLOOR_PLAN_PHOTO_FIELD]: false,
      },
      [InsideSurveyCablingProposal.BUILDING_LAYOUT_SUBTITLE]: {
        [InsideSurveyCablingProposal.BUILDING_LAYOUT_FIELD]: false,
      },
    });
    this.viewmodel = {
      outsideIntroPhotos: this.survey.photos.outsideIntroPhotos.map(
        (e) => new PictureInfo(e)
      ),
      facadePhotos: this.survey.photos.facadePhotos.map(
        (e) => new PictureInfo(e)
      ),
      generalPhotos: this.survey.photos.generalPhotos.map(
        (e) => new PictureInfo(e)
      ),
      undergroundPhotos: this.survey.photos.undergroundPhotos.map(
        (e) => new PictureInfo(e)
      ),
      facadeComment: this.survey.facadePhotoRemark,
      outsideIntroComment: this.survey.outsideIntroPhotoRemark,
      undergroundComment: this.survey.undergroundPhotoRemark,
      generalComment: [],
      floorPlanPhotos: this.survey.photos.floorPlanPhotos.map(
        (e) => new PictureInfo(e)
      ),
      floorPlanComment: this.survey.floorPlanPhotoRemark,
      layoutPhotoURL: this.survey.layoutPhoto,
      layoutStatus: null,
    };

    if (this.survey.layoutPhoto) this.survey.shouldUpdateLayout = false;

    this.mainViewVisible = true;
  }

  getErrors(subTitle?: string, field?: string) {
    return this.formValidationService.getErrors(
      ...[INSIDE_SURVEY_CABLING_PROPOSAL, subTitle, field].filter((x) => !!x)
    );
  }

  getErrorsForTitles(subTitles: string[]): boolean {
    return subTitles?.some((subTitle) =>
      this.formValidationService.getErrors(
        INSIDE_SURVEY_CABLING_PROPOSAL,
        subTitle
      )
    );
  }

  toggleBuildingLayoutEditor() {
    this.toggleLayer(this.buildingLayoutEditorLayer);
  }

  updateLayoutUrl(url: string) {
    this.viewmodel.layoutPhotoURL = url;
  }

  reuploadLayout() {
    this.viewmodel.layoutStatus = PictureUploadState.ongoing;
    this._savingStateService
      .reuploadInsideSurveyCablingLayout()
      .subscribe((s) => (this.viewmodel.layoutStatus = s));
  }

  get layoutVisible() {
    return !this.survey.shouldUpdateLayout;
  }

  private initCamera() {
    this.camera.onSnap &&
      this.camera.onSnap.pipe(first()).subscribe((file) => {
        this.closeLayer(this.cameraLayer);
        if (file) this.addLayoutPhoto({ target: { files: [file] } });
      });

    // this.camera.maxSizeInKb = environment.maxPhotoSizeInKb;
  }

  showCamera() {
    if (!this.isAuthCanWrite) return;
    if (!this.camera.hasCamera) {
      this.toastService.showWarnToast(
        "No camera detected",
        "A camera could not be detected on this device."
      );
      return;
    }
    this.initCamera();

    this.camera.start();
    this.openLayer(this.cameraLayer);
  }

  galleryClick(inputId: string, override: boolean) {
    let observable = of(true);
    if (override)
      observable = this.dialogService.openDialog({
        headerText: $localize`:@@photo.overwrite.header:Overwrite photo`,
        detailText: $localize`:@@photo.overwrite.detailtext:Uploading a new photo will overwrite the existing one. Are you sure?`,
        dialogType: DialogType.Continue,
      });

    observable.pipe(first()).subscribe((res) => {
      if (res)
        this.fileInputs
          .find((x) => x.nativeElement.id === inputId)
          .nativeElement.click();
    });
  }

  addLayoutPhoto(photoPath) {
    let reader = new FileReader();
    const readFile = (result) => {
      reader.readAsDataURL(result);
      reader.onload = (event: Event) => {
        this.viewmodel.layoutStatus = PictureUploadState.ongoing;
        var base64 = event.target[RESULT];
        // this.editor.loadImage(event.target['result']);
        // this.toggleLayer(this.editorLayer);
        // var arrayBuffer = reader.result;
        //  var bytes = new Uint8Array(arrayBuffer);
        // let layoutPhotoDTO = {id: this.survey.id, image: bytes , imageMimeType: photoPath.target.files[0].type};
        var parsedData =
          this._dataConverterService.parseEmbeddedUrlFromBase64(base64);
        this.viewmodel.layoutPhotoURL = base64;
        var dto = new LayoutDto(
          this.survey.id,
          parsedData.data,
          parsedData.mimetype
        );
        if (navigator.onLine) {
          this.insideSurveyService
            .updateLayout(dto)
            .pipe(first())
            .subscribe(
              (x) => {
                this.survey.shouldUpdateLayout = false;
                this.viewmodel.layoutStatus = PictureUploadState.done;
              },
              (err) => {
                this._savingStateService.addInsideSurveyCablingLayout(dto);
                this.viewmodel.layoutStatus = PictureUploadState.failed;
              }
            );
        } else {
          this._savingStateService.addInsideSurveyCablingLayout(dto);
          this.viewmodel.layoutStatus = PictureUploadState.failed;
        }
        photoPath.target.value = "";
      };
    };

    readFile(photoPath.target.files[0]);
  }

  openLayer(layer: HTMLDivElement) {
    layer.classList.remove("hidden");
  }

  closeLayer(layer: HTMLDivElement) {
    layer.classList.add("hidden");
  }

  toggleLayer(layer: HTMLDivElement) {
    layer.classList.toggle("hidden");
  }

  getValidationError(checkValidity?: boolean) {
    if (checkValidity)
      this.formValidationService.resetErrorsForPath(
        INSIDE_SURVEY_CABLING_PROPOSAL
      );
    const validationErrors: ValidationError[] = [];
    if (this.viewmodel.generalPhotos.length === 0) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_CABLING_PROPOSAL,
          InsideSurveyCablingProposal.PHOTO_GENERAL_SUBTITLE,
          InsideSurveyCablingProposal.PHOTO_GENERAL_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@general.warning:Warning`,
          $localize`:@@validation.survey.onegeneralphoto:At least 1 general photo is required.`,
          $localize`:@@survey.inside.cabling.proposal.title.cableproposal:Cabling proposal`
        )
      );
    }
    if (this.viewmodel.outsideIntroPhotos.length === 0) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_CABLING_PROPOSAL,
          InsideSurveyCablingProposal.OUTSIDE_INTRO_PHOTO_SUBTITLE,
          InsideSurveyCablingProposal.OUTSIDE_INTRO_PHOTO_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@general.warning:Warning`,
          $localize`:@@validation.survey.oneoutsidephoto:At least 1 outside photo is required.`,
          $localize`:@@survey.inside.cabling.proposal.title.cableproposal:Cabling proposal`
        )
      );
    }
    if (this.viewmodel.facadePhotos.length === 0) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_CABLING_PROPOSAL,
          InsideSurveyCablingProposal.FACADE_PHOTO_SUBTITLE,
          InsideSurveyCablingProposal.FACADE_PHOTO_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@general.warning:Warning`,
          $localize`:@@validation.survey.onefacadephoto:At least 1 facade photo is required.`,
          $localize`:@@survey.inside.cabling.proposal.title.cableproposal:Cabling proposal`
        )
      );
    }
    if (this.viewmodel.undergroundPhotos.length === 0) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_CABLING_PROPOSAL,
          InsideSurveyCablingProposal.UNDERGROUND_PHOTO_SUBTITLE,
          InsideSurveyCablingProposal.UNDERGROUND_PHOTO_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@general.warning:Warning`,
          $localize`:@@validation.survey.oneundergroundphoto:At least 1 underground photo is required.`,
          $localize`:@@survey.inside.cabling.proposal.title.cableproposal:Cabling proposal`
        )
      );
    }
    if (this.viewmodel.floorPlanPhotos.length < 1) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_CABLING_PROPOSAL,
          InsideSurveyCablingProposal.FLOOR_PLAN_PHOTO_SUBTITLE,
          InsideSurveyCablingProposal.FLOOR_PLAN_PHOTO_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@general.warning:Warning`,
          $localize`:@@validation.survey.onefloorplanhoto:Floor plan photo is required.`,
          $localize`:@@survey.inside.cabling.proposal.title.cableproposal:Cabling proposal`
        )
      );
    }
    if (this.survey.shouldUpdateLayout) {
      if (checkValidity)
        this.formValidationService.addError(
          INSIDE_SURVEY_CABLING_PROPOSAL,
          InsideSurveyCablingProposal.BUILDING_LAYOUT_SUBTITLE,
          InsideSurveyCablingProposal.BUILDING_LAYOUT_FIELD
        );

      validationErrors.push(
        new ValidationError(
          $localize`:@@general.warning:Warning`,
          $localize`:@@validation.survey.buildinglayoutrequired:Building layout is required.`,
          $localize`:@@survey.inside.cabling.proposal.title.cableproposal:Cabling proposal`
        )
      );
    }
    if (validationErrors.length > 0) return validationErrors[0];
    return undefined;
  }

  save(checkValidity?: boolean): Observable<boolean> {
    if (checkValidity) {
      const error = this.getValidationError();
      if (error) {
        this.toastService.showWarnToast(error.title, error.message);
        return of(false);
      }
    }
    if (
      !this.viewmodel.facadePhotos.some((e) => e.remarkChanged) &&
      !this.viewmodel.floorPlanPhotos.some((e) => e.remarkChanged) &&
      !this.viewmodel.generalPhotos.some((e) => e.remarkChanged) &&
      !this.viewmodel.outsideIntroPhotos.some((e) => e.remarkChanged) &&
      !this.viewmodel.undergroundPhotos.some((e) => e.remarkChanged)
    )
      return of(true);

    var photoComments = this.viewmodel.facadePhotos
      .filter((e) => e.remarkChanged)
      .concat(this.viewmodel.floorPlanPhotos.filter((e) => e.remarkChanged))
      .concat(this.viewmodel.generalPhotos.filter((e) => e.remarkChanged))
      .concat(this.viewmodel.outsideIntroPhotos.filter((e) => e.remarkChanged))
      .concat(this.viewmodel.undergroundPhotos.filter((e) => e.remarkChanged))
      .map((f) => {
        f.remarkChanged = false;
        return new GeneralPhotoRemarksDto(
          f.data.id,
          f[this.generalPhotoRemarkFieldName]
        );
      });

    const dto = new ChangeInsideSurveyPhotoRemarksDto(
      this.survey.id,
      null,
      null,
      null,
      photoComments,
      null
    );
    return this._savingStateService.addInsideSurveyPhotoTab(dto);
  }
}
